const state = {
  toasts: [],
}

const mutations = {
  ADD_TOAST (state, toast) {
    state.toasts.push(toast)
  },
  REMOVE_TOAST (state, id) {
    const index = state.toasts.findIndex(t => t.id === id)
    if (index !== -1) {
      state.toasts.splice(index, 1)
    }
  },
  CLEAR_TOASTS (state) {
    state.toasts = []
  },
}

const actions = {
  add ({ commit }, toast) {
    commit('ADD_TOAST', toast)

    // Auto-remove toast after duration
    if (toast.duration > 0) {
      setTimeout(() => {
        commit('REMOVE_TOAST', toast.id)
      }, toast.duration)
    }
  },
  remove ({ commit }, id) {
    commit('REMOVE_TOAST', id)
  },
  clear ({ commit }) {
    commit('CLEAR_TOASTS')
  },
}

const getters = {
  all: state => state.toasts,
  count: state => state.toasts.length,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
